module.exports = __webpack_public_path__ + "media/images/screens/04_categorie_hover-7d64961603c8ccd3c526c7c8ae188b7e.jpg";